import { type ReactElement } from 'react';
import { type UpdateQueryParameterValues } from '../../../hooks/use-update-query-parameter-values';
import { chassisTypes } from '../../../utils/chassis-types';
import styles from './style.module.scss';
import ReactSelect from '@/common/components/ReactSelect';
import toOptions from '@/utils/to-options';
import VerticalDivider from '@/common/components/VerticalDivider';

export interface FilterProperties {
  readonly selectedBatteries: string[];
  readonly selectedConfigurations: string[];
  readonly selectedVehicleTypes: string[];
  readonly selectedPropulsions: string[];
  readonly batteries: string[];
  readonly configurations: string[];
  readonly updateQueryParameterValues: UpdateQueryParameterValues;
}

const Filters = ({
  selectedBatteries,
  selectedConfigurations,
  selectedVehicleTypes,
  selectedPropulsions,
  batteries,
  configurations,
  updateQueryParameterValues,
}: FilterProperties): ReactElement => {
  const batteryOptions = toOptions({ items: batteries, suffix: 'kWh' });
  const configurationOptions = toOptions({ items: configurations });

  const selectedBatteryOptions = toOptions({ items: selectedBatteries, suffix: 'kWh' });
  const selectedConfigurationsOptions = toOptions({ items: selectedConfigurations });
  const selectedVehicleTypeOptions = toOptions({ items: selectedVehicleTypes });

  return (
    <div className={styles.container}>
      <ReactSelect
        label="Chassis type"
        className={styles.select}
        options={toOptions({ items: [...chassisTypes] })}
        selected={selectedVehicleTypeOptions}
        disabled={false}
        onChange={(selected) =>
          updateQueryParameterValues({
            filterKeys: { vehicleType: selected.map((option) => option.value) },
          })
        }
      />
      <VerticalDivider />
      <ReactSelect
        label="Propulsion"
        className={styles.select}
        options={toOptions({ items: ['BEV', 'PHEV'] })}
        selected={toOptions({ items: selectedPropulsions })}
        disabled={false}
        onChange={(selected) =>
          updateQueryParameterValues({
            filterKeys: { propulsion: selected.map((option) => option.value) },
          })
        }
      />
      <VerticalDivider />
      <ReactSelect
        label="Installed Battery"
        className={styles.select}
        options={batteryOptions}
        selected={selectedBatteryOptions}
        disabled={false}
        onChange={(selected) =>
          updateQueryParameterValues({
            filterKeys: { battery: selected.map((option) => option.value) },
          })
        }
      />
      <VerticalDivider />
      <ReactSelect
        label="Wheel configuration"
        className={styles.select}
        options={configurationOptions}
        selected={selectedConfigurationsOptions}
        disabled={false}
        onChange={(selected) =>
          updateQueryParameterValues({
            filterKeys: { configuration: selected.map((option) => option.value) },
          })
        }
      />
    </div>
  );
};

export default Filters;
